import auth from '@/router/middlewares/auth';

export default [
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    redirect: '/'
  },
  {
    path: '/',
    component: () => import('@/pages/dashboard/index.vue'),
    redirect: { name: 'DashboardWorkspaces' },
    name: 'Dashboard',
    meta: {
      layout: 'AuthenticatedLayout',
      middleware: [auth],
      highlight: 'home'
    },
    children: [
      {
        path: '/',
        name: 'DashboardIndex',
        component: () => import('@/pages/dashboard/workspaces.vue'),
        meta: { highlight: 'home' }
      },
      {
        name: 'DashboardWorkspaces',
        path: '/workspace/:workspaceID?/:workspaceName?',
        component: () => import('@/pages/dashboard/workspaces.vue'),
        meta: { highlight: 'home' }
      },
      {
        path: 'album-folders',
        //component: () => import('@/pages/album/folders.vue'),
        component: () => import('@/pages/dashboard/workspaces.vue'),
        name: 'AccountFolders',
        meta: { highlight: 'albums' }
      },
      {
        path: 'albums',
        //component: () => import('@/pages/album/index.vue'),
        component: () => import('@/pages/dashboard/workspaces.vue'),
        name: 'AccountAlbums',
        meta: { highlight: 'albums' }
      },
      {
        path: 'albums/:workspaceID/:workspaceName/',
        //component: () => import('@/pages/album/index.vue'),
        component: () => import('@/pages/dashboard/workspaces.vue'),
        name: 'WorkspaceAlbums',
        meta: { highlight: 'albums' }
      },
      {
        path: 'albums/:workspaceID?/:workspaceName?/:albumId',
        //component: () => import('@/pages/album/album.vue'),
        component: () => import('@/pages/dashboard/workspaces.vue'),
        name: 'Album',
        meta: { highlight: 'albums' }
      }
    ]
  }
];
